module.exports = __webpack_public_path__ + "img/add-contact.80cffff9.svg";